import { DataTypeLti } from '@efdigital/ll-admin-v2/data/data-types/lti';
import { withDefaults } from '@warp-drive/legacy/model/migration-support';

export const LtiConsumedToolSchema = withDefaults({
  type: DataTypeLti.ConsumedTool,
  legacy: true,
  identity: {
    kind: '@id',
    name: 'id',
  },
  fields: [
    { kind: 'attribute', name: 'consumingPlatformId', type: 'string' },
    { kind: 'attribute', name: 'providedToolId', type: 'string' },
    { kind: 'attribute', name: 'platformData' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
    {
      kind: 'belongsTo',
      name: 'consumingPlatform',
      type: DataTypeLti.ConsumingPlatform,
      options: {
        async: true,
        inverse: 'consumedTools',
      },
    },
    {
      kind: 'hasMany',
      name: 'deployments',
      type: DataTypeLti.ConsumedToolDeployment,
      options: {
        async: true,
        inverse: 'consumedTool',
      },
    },
  ],
});
